import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconTrophy } from '@tabler/icons-react';

// Surfaced once the email + Strava Club starter rewards are both claimed: points
// the rider at a challenge, which pays a diamond at every checkpoint reached.
// Navigating closes the nav panel automatically (the nav clears it on route change).
const ChallengeRewardCard = () => {
  const navigate = useNavigate();

  return (
    <div className="reward-card">
      <div className="reward-content">
        <div className="reward-header">
          <h4>
            <IconTrophy size={20} style={{ marginRight: '8px' }} />
            Take on a challenge
          </h4>
          <span className="reward-value">💎 per checkpoint</span>
        </div>
        <p>Take on a Mythic Challenge and earn a diamond at every checkpoint you pass, with a bonus at the finish. Your everyday runs, rides, and walks carry you along legendary routes.</p>
        <button type="button" className="reward-button" onClick={() => navigate('/challenge')}>
          View challenges
        </button>
      </div>
    </div>
  );
};

export default ChallengeRewardCard;
